export default __webpack_public_path__ + "static/media/handprint-24-25-page.74053dad.png";